export default{
    message: (state)=>state.message,
    type: (state)=>state.type,
    visible: (state)=>state.visible,
}